import _ from 'lodash';

export const PLACEHOLDER_IMAGE = '/assets/img/placeholder.png';
export const VAT_RATE = 0.2;
export const COLLECTION_START_TIME = '08:00';
export const COLLECTION_END_TIME = '21:00';
export const moduleName = {
    LOGIN: 'LOGIN',
    REGISTER: 'REGISTER',
    CUSTOMERS: 'CUSTOMERS',
    GET_ALL_PRODUCTS: 'GET_ALL_PRODUCTS',
    GET_PRODUCTS: 'GET_PRODUCTS',
    FAVOURITE: 'FAVOURITE',
    ORDER: 'ORDER',
    ORDER_ITEM: 'ORDER_ITEM',
    POST_ORDER: 'POST_ORDER',
    PROMOTIONS: 'PROMOTIONS',
    ADD_PROMOTION: 'ADD_PROMOTION',
    PROMOTION_BY_CUSTOMER: 'PROMOTION_BY_CUSTOMER',
    ADD_PROMOTION_PRODUCTS: 'ADD_PROMOTION_PRODUCTS',
    POST_PROMOTION: 'POST_PROMOTION',
    GET_INVOICES: 'GET_INVOICES',
}

export const categories = [
    "Basting & Marinades",
    "Breading",
    "Cleaning & Hygeine Essentials",
    "Cooking Essentials",
    "Cooking Oils & Fats",
    "Desserts",
    "Disposable Crockery",
    "Disposable Cutlery",
    "Disposable Packaging",
    "Flour & Breadings",
    "Fresh Poultry-Other",
    "Kitchen Essentials",
    "Sachets",
    "Sauces",
    "Sides",
    "Smoothie Drinks",
    "Soft Drinks",
    "Syrups",
    "Till Labels and Receipt Rolls",
    "Water Drinks",
    "Operational Products",
    "Uniform",
    "Fresh Lamb & Beef",
    "Fresh Poultry-Chicken Legs",
    "Fresh Poultry-Fillets",
    "Fresh Poultry-Whole Chicken",
    "Fresh Poultry-Wings",
    "Fruits",
    "Operational Product",
    "Burgers",
    "Chicken Products",
    "Fries & Other Potato Products",
    "Frozen Poultry- Fillets",
    "Lamb & Beef",
    "Pizza Toppings & Other Toppings",
    "Seafood",
    "Vegetarian Products",
    "Items",
    "Non Items"
];

export const businessTypes = _.sortBy([
    { id: 1, text: "Afghan Restaurant" },
    { id: 2, text: "American Restaurant" },
    { id: 3, text: "Bakeries and Pastry Shops" },
    { id: 4, text: "Bakery Manufacturer" },
    { id: 5, text: "Bar / Pub with Foodservice" },
    { id: 6, text: "Barbecue / Grill" },
    { id: 7, text: "Burger Restaurant" },
    { id: 8, text: "Butchers" },
    { id: 9, text: "Café / Coffee Shop" },
    { id: 10, text: "Caribbean Restaurant" },
    { id: 11, text: "Casual Dining Restaurant" },
    { id: 12, text: "Caterer (On-site or Off-site)" },
    { id: 13, text: "Charity / Religious Group Foodservice" },
    { id: 14, text: "Chinese Restaurant" },
    { id: 15, text: "Contract Catering / Institutional Catering" },
    { id: 16, text: "Convenience Store with Foodservice" },
    { id: 17, text: "Corporate Catering" },
    { id: 18, text: "Delis and Sandwich Shops" },
    { id: 19, text: "European Restaurant" },
    { id: 20, text: "Event / Wedding Catering" },
    { id: 21, text: "Fast Casual Restaurant" },
    { id: 22, text: "Fine Dining Restaurant" },
    { id: 23, text: "Fish and Chips Shop" },
    { id: 24, text: "Fishmonger" },
    { id: 25, text: "Food Distributor / Logistics Provider" },
    { id: 26, text: "Fried Chicken Shop" },
    { id: 27, text: "Frozen Food Manufacturer" },
    { id: 28, text: "General Food Store" },
    { id: 29, text: "General Wholesaler" },
    { id: 30, text: "Healthcare / Hospital Catering" },
    { id: 31, text: "Hotel Catering / Banquets" },
    { id: 32, text: "Hotel with Restaurants" },
    { id: 33, text: "Ice Cream Shop / Dessert Café" },
    { id: 34, text: "Indian Restaurant" },
    { id: 35, text: "Italian Restaurant" },
    { id: 36, text: "Japanese Restaurant" },
    { id: 37, text: "Juice Bar / Smoothie Bar" },
    { id: 38, text: "Kebab Shop" },
    { id: 57, text: "Mexican" },
    { id: 39, text: "Mediterranean Restaurant" },
    { id: 40, text: "Middle Eastern Restaurant" },
    { id: 41, text: "Other" },
    { id: 42, text: "Pakistani Restaurant" },
    { id: 43, text: "Piri Piri Shop" },
    { id: 44, text: "Pizza Shop" },
    { id: 45, text: "Prepared Meals Manufacturer" },
    { id: 46, text: "Quick-Service Restaurant (QSR)" },
    { id: 47, text: "Resort Foodservice" },
    { id: 48, text: "School / University Catering" },
    { id: 49, text: "Shisha Lounge" },
    { id: 50, text: "Specialty Ethnic Grocery with Foodservice" },
    { id: 51, text: "Wholesale Butcher" },
    { id: 52, text: "Wholesale Cash & Carry" },
    { id: 53, text: "Wholesale Drinks Supplier" },
    { id: 54, text: "Wholesale Foodservice Supplier" },
    { id: 55, text: "Wine Bar with Foodservice" },
    { id: 56, text: "Workplace Canteen" },
], ['text']);

export const terms = [
    { value: 1, label: 'Account' },
    { value: 2, label: 'Cash on Delivery' },
]

export const ORDER_TYPES = [
    { value: 2, label: 'Delivery' },
    { value: 1, label: 'Collection' },
];


export const promotionTypes = [
    {
        value: 1,
        label: 'Applies to All',
    },
    {
        value: 2,
        label: 'Include these customers',
    },
    {
        value: 3,
        label: 'Exclude these customers',
    },
    {
        value: 4,
        label: 'Customer Specific Promotion',
    },
];


export const buttonStates = {
    // remove: { color: 'red', label: 'Remove' },
    update: { color: 'geekblue', label: 'Update' },
    add: { color: 'primary', label: 'Add' },
};

export const statusMap = {
    0: { label: 'Pending', color: 'orange-inverse' },
    1: { label: 'Approved', color: 'green-inverse' },
    2: { label: 'Rejected', color: 'red-inverse' },
};

export const deliveryDays = [
    { label: "Monday", value: 1 },
    { label: "Tuesday", value: 2 },
    { label: "Wednesday", value: 3 },
    { label: "Thursday", value: 4 },
    { label: "Friday", value: 5 },
    { label: "Saturday", value: 6 },
    { label: "Sunday", value: 7 },
]

export const designations = [
    { value: 1, label: 'Owner' },
    { value: 2, label: 'Manager' },
    { value: 3, label: 'Supervisor' },
    { value: 4, label: 'Purchaser' },
]

export const PROMOTIONAL_TABS = {
    OFFERS: 'offers',
    RECENT: 'recent',
    PREFERRED: 'preferred',
}

export const callListTypes = [
    { value: 2, label: 'Ordering Day' },
    { value: 1, label: 'Delivery Day' },
]

export const callOutcomeOptions = [
    {
        label: "General",
        options: [
            { label: "Call Back Later", value: 1 },
            { label: "No Response", value: 2 },
            { label: "Voicemail", value: 3 },
            { label: "Collection", value: 4 },
            { label: "Email", value: 5 },
            { label: "WhatsApp", value: 6 },
            { label: "3CX", value: 7 },
        ],
    },
    {
        label: "New Customer",
        options: [
            { label: "Mailshot", value: 8 },
            { label: "Website", value: 9 },
            { label: "Field Sales", value: 10 },
        ],
    },
    {
        label: "Miscellaneous",
        options: [
            { label: "Dead Customer", value: 11 },
            { label: "Other (Please Specify)", value: 12 },
        ],
    },
];

export const orderStatusTypes = [
    { value: 1, label: 'Ordered' },
    { value: 2, label: 'Not Ordered' },
]

export const leadType = {
    1: { label: 'New Lead', color: 'orange-inverse' },
    2: { label: 'Active Customer', color: 'green-inverse' },
    3: { label: 'Inactive Customer', color: 'red-inverse' },
}

export const wonStatus = {
    1: { label: 'In Progress', color: 'orange-inverse' },
    2: { label: 'Won', color: 'green-inverse' },
    3: { label: 'Lost', color: 'red-inverse' },
}

export const leadFilterOptions = [
    { label: 'In Progress', value: 1 },
    { label: 'Won', value: 2 },
    { label: 'Lost', value: 3 }
]

export const leadStatus = {
    1: { label: 'In Progress', color: 'orange-inverse' },
    2: { label: 'Won', color: 'green-inverse' },
    3: { label: 'Lost', color: 'red-inverse' },
}

export const customerResponseOptions = [
    { label: 'Asked for prices', value: 1 },
    { label: 'Asked to revisit another time', value: 2 },
    { label: 'Asked for management to contact', value: 3 },
    { label: 'Asked for catalogue', value: 4 },
    { label: 'Not interested', value: 5 },
]

export const nextActionOptions = [
    { label: 'To revisit with prices', value: 1 },
    { label: 'To revisit with special request responses', value: 2 },
    { label: 'To revisit with management', value: 3 },
    { label: 'To revisit on specific date', value: 4 },
    { label: 'To contact Head Office or Buying Department', value: 5 },
    { label: 'Lead Not Interested', value: 6 },
]

export const leadStages = [
    { value: 1, label: '1. Follow Up' },
    { value: 2, label: '2. Communication / No Response' },
    { value: 3, label: '3. Pricing' },
    { value: 4, label: '4. Negotiation' },
    { value: 5, label: '5. On-boarding' },
];

export const leadRouteStatus = [
    { value: 1, label: 'Planned' },
    { value: 2, label: 'Completed' },
    { value: 3, label: 'Cancelled' },
]

export const regions = [
    "Luton",
    "Watford",
    "Birmingham",
    "Bournemouth",
    "Brighton",
    "Bristol",
    "East London",
    "Southwest London",
    "Southeast London",
    "Nottingham",
    "West London",
    "North London",
    "Exeter",
    "Gloucester",
    "Portsmouth",
    "Northwest London",
    "Oxford + High Wycombe",
    "Leicester",
    "Manchester",
    "Reading",
    "Southhampton",
    "Slough",
    "Hounslow",
    "Southhall"
];

export const CATEGORY_COLORS = [
    '#7c3aed', '#3b82f6', '#10b981', '#f59e0b', '#ef4444',
    '#8b5cf6', '#06b6d4', '#f97316', '#ec4899', '#22c55e',
    '#6366f1', '#14b8a6', '#f43f5e', '#84cc16', '#d946ef',
    '#0ea5e9', '#fbbf24', '#4f46e5', '#059669', '#dc2626'
];